<template>
  <div class="main-div">
    <live-system-top-header></live-system-top-header>
    <div class="bottom-root-div">
      <left-menu ref="leftMenu" class="left-menu" @menuItemClick="leftMenuItemClick"></left-menu>
      <router-view class="right-root-div"></router-view>
    </div>
  </div>
</template>

<script>
import LiveSystemTopHeader from '../../components/live/LiveSystemTopHeader'
import LeftMenu from '../../components/live/LeftMenu'
export default {
  name: 'StuSystemIndex',
  components: {LeftMenu, LiveSystemTopHeader},
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/stuIndex') {
          that.getUserMenuData()
        }
      },
      deep: true
    }
  },
  created () {
    this.getUserInfo()
    this.getUserMenuData()
  },
  mounted () {

  },
  methods: {
    getUserInfo () {
      // 获取用户信息
      this.$api.liveServer.getUserInfo({}).then(res => {
        if (res.code === 0) this.$store.state.userInfo = res.data
      })
    },
    getUserMenuData () {
      let routerPath = this.$route.path
      let selectToday = (routerPath === '/stuIndex/' || routerPath === '/stuIndex')
      let selectedCourse = routerPath === '/stuIndex/courses'
      let selectMessage = routerPath === '/stuIndex/message'
      let menuList = [
        {title: '今日课程', path: '', selected: selectToday},
        {title: '我的课程', path: 'courses', selected: selectedCourse},
        {title: '消息', path: 'message', selected: selectMessage}]
      if (this.$refs.leftMenu === null || this.$refs.leftMenu === undefined) {
        let that = this
        setTimeout(function () {
          that.$refs.leftMenu.setMenuList(menuList)
        }, 200)
      } else {
        this.$refs.leftMenu.setMenuList(menuList)
      }
    },
    leftMenuItemClick (item) {
      let path = '/stuIndex/' + item.path
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../style/mixin-bak';
  .main-div{
    background-color: #F0F0F0;
    // text-align: center;
  }
  .bottom-root-div{
    margin: 0 auto;
    margin-top: 20px;
    width: 1200px;
    height: 100%;
  }
  .left-menu{
    height: 400px;
    width: 230px;
    float: left;
  }
  .right-root-div{
    margin-left: 20px;
    width: 950px;
    float: right;
    background-color: #FFFFFF;
  }

</style>



// WEBPACK FOOTER //
// src/page/stuSystem/StuSystemIndex.vue